'use client';
import { usePathname } from 'next/navigation';
import {
    SkeletonProjectItemsGlobal,
    SkeletonExperienceItemsGlobal,
    SkeletonExperienceItemDetails,
    SkeletonSkillsAndTrainings,
    SkeletonGamesItemsGlobal,
    SkeletonBlogPostItemsGlobal,
    SkeletonBlogPostItem,
    WorkWithMeSkeleton,
    SkeletonHomePage,
    SkeletonProjectItem,
} from "@/components/Skeletons";
import DisplayProgressCircles, { DisplayProgressCirclesType } from "@/components/DisplayProgressCircles";
import 'react-vertical-timeline-component/style.min.css';

const pageMaps: Record<string, React.ComponentType<any>> = {
    '/': SkeletonHomePage,
    '/project/': SkeletonProjectItem,
    '/education/': SkeletonExperienceItemDetails,
    '/experience/': SkeletonExperienceItemDetails,
    '/work/': SkeletonExperienceItemDetails,
    '/blog/': SkeletonBlogPostItem,
    '/work': SkeletonExperienceItemsGlobal,
    '/education': SkeletonExperienceItemsGlobal,
    '/experience': SkeletonExperienceItemsGlobal,
    '/projects': SkeletonProjectItemsGlobal,
    '/skills': SkeletonSkillsAndTrainings,
    '/skills-and-trainings': SkeletonSkillsAndTrainings,
    '/games': SkeletonGamesItemsGlobal,
    '/blog': SkeletonBlogPostItemsGlobal,
    '/contact': WorkWithMeSkeleton,
    '/contact-me': WorkWithMeSkeleton,
    '/contact-us': WorkWithMeSkeleton,
    '/work-with-me': WorkWithMeSkeleton,
}

export default function Loading({ n=3, colors=['#C66', '#6C6', '#66C'], style={ width: '28px', height: '28px' }, containerClassName = '', containerStyle = {} } : DisplayProgressCirclesType) {
    const pathname = usePathname();
    if (pathname) {
        if (pageMaps[pathname]) {
            const Component = pageMaps[pathname];
            return <Component />;
        } else {
            for (const key in pageMaps) {
                if (key !== '/' && pathname.startsWith(key)) {
                    const Component = pageMaps[key];
                    return <Component />;
                }
            }
        }
    }

    return (
        <div style={{ display: 'grid', placeItems: 'center', height: 'calc(100vh - 350px)'}}>
            <DisplayProgressCircles n={n} colors={colors} style={style} containerClassName={containerClassName} containerStyle={containerStyle} />
        </div>
    );
}